export default __webpack_public_path__ + "static/media/Whack2Words_0323.8488e47d.svg";